import type { ReactNode } from 'react';
import { Logomark } from '../../../atoms/Logomark/Logomark';
import { Text } from '../../../atoms/Text/Text';
import styles from './PageState.module.css';

export type PageStateProps = {
  title: string;
  description?: ReactNode;
  /** A button or two. */
  actions?: ReactNode;
  /** Fill the viewport (outside the Shell) instead of the content column. */
  fullScreen?: boolean;
  /** `status` (polite) for loading/empty, `alert` for failures. */
  role?: 'status' | 'alert';
};

/**
 * A whole-page message: 404, a failed load, a source that is not connected,
 * an unsupported browser. **Not in Figma** (docs/design/open-questions.md #6) —
 * built from Reef's type scale and tokens as an interim until designed.
 */
export function PageState({ title, description, actions, fullScreen = false, role = 'status' }: PageStateProps) {
  return (
    <div className={[styles.root, fullScreen && styles.fullScreen].filter(Boolean).join(' ')} role={role}>
      <Logomark />
      <Text as="h1" size="md" weight="semibold" color="primary">
        {title}
      </Text>
      {description !== undefined && (
        <Text as="p" size="sm" color="tertiary" className={styles.description}>
          {description}
        </Text>
      )}
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
